import * as TYPES from '../actions/conv';
import { storage } from 'utils';
import { isPageMessages, nullInPath } from 'selectors';
import { loadAndWatchReducer } from './load_and_watch';

export const update_array = (state, key, payload, comp, unshift = false) => {
  if (!state[key]) {
    return { ...state, [key]: [payload] };
  }
  const index = state[key].findIndex(comp);
  if (index < 0) {
    if (unshift) {
      return { ...state, [key]: [payload, ...state[key]] };
    }
    return { ...state, [key]: [...state[key], payload] };
  }
  return { ...state, [key]: [...state[key].slice(0, index), payload, ...state[key].slice(index + 1)] };
};

const convReduce = (state, action) => {
  let new_state;
  let messages;
  switch (action.type) {
    case TYPES.SET_STORED_CONVS:
      new_state = { list: action.payload };
      return new_state;
    case TYPES.UPDATE_CONV:
      new_state = update_array(state, 'list', action.payload, conv => conv.id === action.payload.id);
      new_state.list.sort((a, b) => b.last_msg.created - a.last_msg.created);
      storage.set('cached_convs', new_state.list);
      return new_state;
    case TYPES.LOAD_PREV_MESSAGES:
      messages = isPageMessages(action.payload.id, state) ? 'page_messages' : 'recent_messages';
      if (Object.keys(action.payload.data).length === 0) {
        return state;
      }
      new_state = {
        ...state,
        [action.payload.id]: { ...state[action.payload.id], [messages]: { ...action.payload.data, ...state[action.payload.id][messages] } }
      };
      return new_state;
    case TYPES.LOAD_NEXT_MESSAGES:
      messages = isPageMessages(action.payload.id, state) ? 'page_messages' : 'recent_messages';
      if (Object.keys(action.payload.data).length === 0) {
        return state;
      }
      new_state = {
        ...state,
        [action.payload.id]: { ...state[action.payload.id], [messages]: { ...state[action.payload.id][messages], ...action.payload.data } }
      };
      return new_state;
    case TYPES.UPDATE_MESSAGES:
      const recent_state = updateMessageReducer(state, action, 'recent_messages');
      const page_state = updateMessageReducer(state, action, 'page_messages');
      recent_state[action.payload.id].page_messages = page_state[action.payload.id].page_messages;
      return recent_state;
    case TYPES.EMPTY_PAGE_MESSAGES:
      return {
        ...state,
        [action.payload.id]: { ...state[action.payload.id], page_messages: null }
      };
    default:
      return loadAndWatchReducer(state, action, action.attr_name);
  }
};

const updateMessageReducer = (state, action, message_type) => {
  if (nullInPath(state, action.payload.id, message_type, action.payload.data.id)) {
    return {
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        [message_type]: { ...state[action.payload.id].recent_messages, [action.payload.data.id]: action.payload.data }
      }
    };
  }
  return state;
};

export default convReduce;



// WEBPACK FOOTER //
// ./src/reducers/conv.js